// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import classnames from 'classnames';
import {Route, withRouter, NavLink} from 'react-router-dom';
import {Button} from 'primereact/button';
import servicesConfig from '../../config/services-config';

// Components
import ShelfItemThumbnails from '../components-app/shelfitem-thumbnails';
import SubShelfBreadcrumbs from './subshelf-breadcrumbs';
import DashboardSubShelf from '../components-layout/dashboard-sub-shelf';

// Styles
import './subshelf-detail.scss';

import searchHoc from '../components-app/search-wrapper';
import Loading from '../components-core/loading';
import Icon from '../components-core/icon';

const servicesDataKey = 'loadSubShelves';
const styles = {
    headerButton: {marginRight: 10},
    mainNav: {marginLeft: 22, marginTop: 0},
};

class SubShelfDetail extends Component {
    getSearchValues() {
        return get(this.props, 'searchData.ShelfDTO.subShelves', {});
    }

    getTitle() {
        return get(this.props, 'searchData.ShelfDTO', {});
    }

    getThumbnailProps(parentId) {
        const {error, fetching, match} = this.props;

        return {
            className: 'subshelf-detail--thumbnail-group',
            error,
            parentId,
            fetching,
            shelfWebObj: this.getSearchValues(),
            matchUrl: match.url,
        };
    }

    getBreadcrumbsProps() {
        const {match} = this.props;

        return {
            matchUrl: match.url,
        };
    }

    getNavLinkProps() {
        return {
            activeClassName: 'main-nav--link_active',
            className: 'main-nav--link button',
        };
    }

    getClass() {
        const {className} = this.props;

        return classnames(className, 'main-nav');
    }

    render() {
        const {fetched, match, history} = this.props;

        const subShelfObj = this.getTitle();
        const parentId = subShelfObj.id;
        const addShelfUrl = `/add-shelf/${parentId}`;
        const reorderShelfUrl = `/reorder-shelves/${parentId}`;
        const manageShelfUrl = `/manage-shelves/${parentId}`;

        // The following block will be unreachable if DashboardMediaItems also does the same check
        if (match.isExact === false) {
            return (
                <div>
                    <Route component={DashboardSubShelf} path={`${match.url}/:shelfid`} />
                </div>
            );
        }

        // As above temporary solution to specify the id of the ShelfDTO(Web)
        // to the searchHoc component in ShelfItemThumbnails to load the
        // corresponding ShelfDTO(Stb) that contains the thumbnail images.
        servicesConfig.loadSubShelvesResults.path = 'subShelves/' + parentId;

        return fetched ? (
            <div className="subshelf-detail">
                <nav className={this.getClass()} style={styles.mainNav}>
                    <Button
                        className="p-button-primary"
                        label="Add new Shelf"
                        style={styles.headerButton}
                        onClick={() => history.push(addShelfUrl)}
                    />
                    <Button
                        className="p-button-primary"
                        label="Change Order"
                        style={styles.headerButton}
                        onClick={() => history.push(reorderShelfUrl)}
                    />
                    <Button
                        className="p-button-primary"
                        label="Manage Shelves"
                        style={styles.headerButton}
                        onClick={() => history.push(manageShelfUrl)}
                    />
                    <SubShelfBreadcrumbs {...this.getBreadcrumbsProps()} />
                </nav>

                <ShelfItemThumbnails {...this.getThumbnailProps(parentId)} />
                <Route component={DashboardSubShelf} path={`${match.url}/:shelfid`} />
            </div>
        ) : (
            <Loading className="thumbnail--loading" loading={true} progressText="Loading content..." small={true} />
        );
    }
}

SubShelfDetail.propTypes = {
    className: PropTypes.object,
    error: PropTypes.string,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    history: PropTypes.object,
    mapping: PropTypes.bool,
    match: PropTypes.object,
    routerParams: PropTypes.object,
    searchData: PropTypes.object.isRequired,
};

export default withRouter(searchHoc(SubShelfDetail, servicesDataKey));
